import React from 'lib/react';
import PropTypes from 'prop-types';
import {
  EVInputLabel,
  EVTextField,
} from 'lib/components';
import clsx from 'lib/clsx';

function DatePicker(props) {
  const {
    handleChange, helperText, inputFieldProps, inputId, inputLabelProps, inputValue, isRequired, labelText, size,
  } = props;
  const isError = Boolean(helperText || (isRequired && inputValue === ''));

  const { className: inputLabelClassName, ...restInputLabelProps } = inputLabelProps;

  const handleDateChange = ({ target: { value } }) => handleChange(value);

  return (
    <>
      {labelText && (
        <EVInputLabel required={isRequired} {...restInputLabelProps} className={clsx(inputLabelClassName, isError && 'error')}>
          {labelText}
        </EVInputLabel>
      )}
      <EVTextField
        fullWidth
        value={inputValue}
        onChange={handleDateChange}
        id={inputId}
        error={isError}
        variant="outlined"
        type="date"
        size={size}
        helperText={helperText || (isError && 'This field is required')}
        inputProps={{ min: '1900-01-01' }}
        {...inputFieldProps}
      />

    </>
  );
}

DatePicker.defaultProps = {
  helperText: '',
  inputLabelProps: {},
  inputId: '',
  inputValue: '',
  inputFieldProps: {},
  isRequired: false,
  labelText: '',
  size: 'medium',
};

DatePicker.propTypes = {
  handleChange: PropTypes.func.isRequired,
  helperText: PropTypes.string,
  inputLabelProps: PropTypes.shape(),
  inputId: PropTypes.string,
  inputValue: PropTypes.string,
  inputFieldProps: PropTypes.shape(),
  isRequired: PropTypes.bool,
  labelText: PropTypes.string,
  size: PropTypes.string,
};
export default DatePicker;
